import { Pipe, PipeTransform } from '@angular/core';
import { FlightOperation } from '@mocca-technologies/model';

@Pipe({
    name: 'checkVisibility'
})

export class CheckVisibilityPipe implements PipeTransform {
    transform(
        operation: FlightOperation,
        operationSelected: FlightOperation,
        searchTerm: string,
    ): boolean {
        // Is Selected?
        const selectedCondition = operation.uniqueId !== operationSelected?.uniqueId;

        const searchCondition =
        !searchTerm ||
        Object.values({
            countryName: operation?.timeZone?.countryName,
            countrySubdivision1: operation?.timeZone?.countrySubdivision1,
            countrySubdivision2: operation?.timeZone?.countrySubdivision2,
            countrySubdivision3: operation?.timeZone?.countrySubdivision3,
        })
            .join(' ')
            .toLowerCase()
            .normalize('NFD') // Normalize to decompose accented characters
            .replace(/[\u0300-\u036f]/g, '') // Remove diacritical marks
            .includes(searchTerm
                .toLowerCase()
                .normalize('NFD') // Apply the same normalization to searchTerm
                .replace(/[\u0300-\u036f]/g, ''));

        // Hide when filters matches BUT doesn't apply on already selected ones
        return selectedCondition && (!searchCondition);
    }
}

@Pipe({
    name: 'countryFormat'
})
export class CountryFormatPipe implements PipeTransform {
    transform(operation: FlightOperation): string {
        let message = "";
        if (operation?.timeZone?.countrySubdivision3) {
            message += `${operation?.timeZone?.countrySubdivision3}, `;
        }
        if (operation?.timeZone?.countrySubdivision2) {
            message += `${operation?.timeZone?.countrySubdivision2}, `;
        }
        if (operation?.timeZone?.countrySubdivision1) {
            message += `${operation?.timeZone?.countrySubdivision1}, `;
        }
        message += operation?.timeZone?.countryName;


        return message;
    }
}
